import { useState, useEffect } from 'react'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import { colors } from '../styles/theme'

const SearchBar = ({ onSearch, placeholder = 'Search episodes...' }) => {
  const [query, setQuery] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(query)
    }, 300)

    return () => clearTimeout(timer)
  }, [query, onSearch])

  const handleClear = () => {
    setQuery('')
  }

  return (
    <TextField
      fullWidth
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      placeholder={placeholder}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: colors.info }} />
          </InputAdornment>
        ),
        endAdornment: query && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} size="small" aria-label="Clear search">
              <CloseIcon sx={{ color: colors.textMuted }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: colors.bgCard,
          color: colors.textPrimary,
          '& fieldset': { borderColor: colors.bgCard },
          '&:hover fieldset': { borderColor: colors.info },
          '&.Mui-focused fieldset': { borderColor: colors.info },
        },
        '& .MuiOutlinedInput-input': {
          color: colors.textPrimary,
          '&::placeholder': {
            color: colors.textMuted,
            opacity: 1,
          },
        },
      }}
    />
  )
}

export default SearchBar
